export default __webpack_public_path__ + "static/media/bloodpuddle.2fd64702.png";